import React from "react";
import "./review-item.css";
import { Typography } from "@mui/material";
import LinearGoldText from "./linear-gold-text.tsx";

export default function ReviewItem({
  id,
  description,
  name,
  rating,
  logo,
  isMobile,
}) {
  const FilledStar = require("../images/feedback/filled-star.png");
  const EmptyStar = require("../images/feedback/empty-star.png");
  const EmptyAmount = new Array(5 - rating).fill(" ");
  return (
    <div key={id} style={{ paddingLeft: "10px", paddingRight: "10px" }}>
      <div
        className="item-container"
        style={{
          minHeight: isMobile ? "135px" : "155px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <img
            src={logo}
            alt="Brand"
            height={isMobile ? "40px" : "50px"}
            style={{ maxWidth: "30%", objectFit: "contain" }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <LinearGoldText
              isMobile={false}
              style={{
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: "600",
              }}
            >
              {name}
            </LinearGoldText>

            <div
              style={{
                width: "80px",
                gap: "5px",
                display: "grid",
                marginTop: "5px",
                gridTemplateColumns: "repeat(5, auto)",
              }}
            >
              {new Array(rating).fill(" ").map((item, index) => (
                <img
                  key={index}
                  src={FilledStar}
                  width={"10px"}
                  alt="Star"
                  style={{ objectFit: "contain" }}
                />
              ))}
              {EmptyAmount.map((item, index) => (
                <img
                  key={index}
                  src={EmptyStar}
                  width={"10px"}
                  alt="Star"
                  style={{ objectFit: "contain" }}
                />
              ))}
            </div>
          </div>
        </div>
        <div style={{ paddingTop: "20px" }}>
          <Typography
            style={{ fontSize: isMobile ? "12px" : "14px", fontWeight: "400" }}
          >
            {description}
          </Typography>
        </div>
      </div>
    </div>
  );
}
